import * as types from '../constants/actionTypes'

export const notificationsState = (state: any[] = [], action) => {
  switch (action.type) {
    case types.ShowNotification:
      return [...state, action.notification]
    case types.HideNotification:
      return state.filter(
        (notification) => notification.message !== action.message
      )
    default:
      return state
  }
}

export const notifications = notificationsState
